/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 * If attribute is already filtered enable the button to allow user to reset the filter
 */

import React from 'react';

import Dyn from '../../../lib/dynDataSet/dynMiscellany';
import PlainButton from '../../common/PlainButton';

class ResetFilterComponent extends React.Component {
  // componentWillMount = () => {
    //   // on umount remove the message subscription to avoid warnings
    //   mediator.remove( "records:caseFilterByAttribute", this.handleReset );
    // // Listen to reset filter
    // mediator.subscribe( "records:caseFilterByAttribute", this.handleReset);
    // use it for the button display property, blue or grey
    // this.setState({
    //   isFiltered: this.props.isFiltered
    // });
  // }

  // handleReset = ( args ) => {
  //   if( !args.categories && !args.numeric && args.attributeID === this.props.attributeObj.id ) {
  //     this.setState({
  //       isFiltered: false
  //     });
  //
  //     // once its reset, the categorylist/slider componenet needs to be reloaded.
  //     // either send signal, or see if we can explicitly call the init component
  //     // of the slider/ attributeobj
  //     // this.state may not be updated right away, so using the actual value
  //     // instead.
  //     this.props.handleChange({isFiltered: false });
  //   }
  // }

  changeHandler = (event) => {

    _gaq.push(['_trackEvent', 'Filter Function', 'Click', 'AttributeFilterReset']);
    // publish the message to reset the filter applied for the attribute
    // mediator.publish( "records:caseFilterByAttribute", {
    //   "attributeID": this.props.attributeObj.id
    // });
    this.props.handleChange({
        isFiltered: false,
        component: 'reset'
    });
  }


  render = () => {

    var attributeObj = this.props.attributeObj;

    if ( this.props.isFiltered ){
      return (
          <PlainButton onClick={this.changeHandler} className="tde-reset-filter tde-s2 tde-font-weight-regular tde-float-right tde-mr-3">{this.props.value}</PlainButton>
      );
      /*return (
        <div className="filterFooter">
          <div className="resetFilterSection left" onClick={this.props.handleClose} >
            <div className="data-exploration-button cancel">Close</div>
          </div>
          <div className="resetFilterSection right" onClick={this.changeHandler} >
            <div className="data-exploration-button big">Reset Filter</div>
          </div>
        </div>
      );*/
    } else {
        return (
            <PlainButton disabled={true} className="tde-reset-filter tde-s2">{this.props.value}</PlainButton>
        );
      /*return (
        <div className="filterFooter">
          <div className="resetFilterSection left" onClick={this.props.handleClose} >
            <div className="data-exploration-button cancel">Close</div>
          </div>
          <div className="resetFilterSection right" >
            <div title="No filter applied" className="data-exploration-button big disabled">
              Reset Filter
            </div>
          </div>
        </div>
      );*/
    }
  }
}

export default ResetFilterComponent
